module.exports = Em.Component.extend({
    changeset: null,

    actions: {
        fileSelected: function(files) {
            this.get('changeset').add(files)
        }
    }
})
